import OrderLogApi from '@apis/order/OrderLogApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetOrderLogsParams } from '@models/order/orderLog';

const orderLogQueries = createQueryKeys('orderLog', {
    list: (params: Omit<GetOrderLogsParams, 'page'>) => ({
        queryKey: ['list', params],
    }),
    detail: (orderNo: string) => ({
        queryKey: ['detail', orderNo],
        queryFn: () => OrderLogApi.getOrderLog(orderNo),
    }),
});

export default orderLogQueries;
